import React from 'react';
import { useGetPublisherConsentsQuery } from '../../../api/publisherApiSlice';
import ConsentPie from '../../metrics/ConsentPie';

const PublisherConsentPie = ( { source, title, publisherId, startDate, endDate } ) => {
  const { data = [], isSuccess, isLoading, refetch } = useGetPublisherConsentsQuery({publisherId, startDate, endDate})
  return (
    <ConsentPie title={title} source={source} data={data} loaderProps={{isLoading, isSuccess, retry: refetch}}/>
  )
}

export default PublisherConsentPie
